"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateUpgradeProduct = exports.validatePurchaseConfig = exports.validatePurchaseableItemInConfig = exports.validateProductBasedOffers = exports.validateItemConfigurations = exports.validateCurrencyCode = exports.validateProductBasedOfferId = exports.validateMerchandiseId = exports.validateTermId = void 0;

var _helpers = require("self-service-api/core/utilities/helpers");

var CurrencyCodes = _interopRequireWildcard(require("self-service-api/constants/CurrencyCodes"));

var MerchandiseIds = _interopRequireWildcard(require("self-service-api/constants/MerchandiseIds"));

var TermIds = _interopRequireWildcard(require("self-service-api/constants/TermIds"));

var UpgradeProducts = _interopRequireWildcard(require("self-service-api/constants/UpgradeProducts"));

var ProductBasedOfferIds = _interopRequireWildcard(require("self-service-api/constants/ProductBasedOfferIds"));

var _ChargeTypes = require("self-service-api/constants/ChargeTypes");

var currencyCodeValues = Object.values(CurrencyCodes || {});
var merchandiseIdValues = Object.values(MerchandiseIds || {});
var termIdValues = Object.values(TermIds || {});
var upgradeProductValues = Object.values(UpgradeProducts || {});
var productBasedOfferIdValues = Object.values(ProductBasedOfferIds || {});

var validateTermId = function validateTermId(termId) {
  if (termId === null || termId === undefined) {
    return;
  }

  if (termIdValues.indexOf(termId) === -1) {
    throw new Error("Invalid termId, must be one of: " + termIdValues);
  }
};

exports.validateTermId = validateTermId;

var validateMerchandiseId = function validateMerchandiseId(merchandiseId) {
  if (merchandiseIdValues.indexOf(merchandiseId) === -1) {
    throw new Error("Invalid merchandiseId (" + merchandiseId + "), must be one of: " + merchandiseIdValues);
  }
};

exports.validateMerchandiseId = validateMerchandiseId;

var validateProductBasedOfferId = function validateProductBasedOfferId(productBasedOfferId) {
  if (productBasedOfferIdValues.indexOf(productBasedOfferId) === -1) {
    throw new Error("Invalid productBasedOfferId, must be one of: " + productBasedOfferIdValues);
  }
};

exports.validateProductBasedOfferId = validateProductBasedOfferId;

var validateCurrencyCode = function validateCurrencyCode(currencyCode) {
  if (currencyCodeValues.indexOf(currencyCode) === -1) {
    throw new Error("Invalid currencyCode, must be one of: " + currencyCodeValues);
  }
};

exports.validateCurrencyCode = validateCurrencyCode;

var validateItemConfigurations = function validateItemConfigurations(itemConfigurations) {
  if (itemConfigurations === null || itemConfigurations === undefined || Array.isArray(itemConfigurations) && !itemConfigurations.length) {
    return;
  }

  if (!Array.isArray(itemConfigurations)) {
    throw new Error("Invalid itemConfigurations: " + JSON.stringify(itemConfigurations) + ", must be null, undefined, or an array");
  }

  itemConfigurations.forEach(function (itemConfiguration) {
    // The offer builder API uses the property name "id" but we enforce
    // "merchandiseId" for clarity and later transform it for the API
    validateMerchandiseId(itemConfiguration.merchandiseId); // The offer builder API supports null values for quantity and defaults
    // to 1 on the backend but we enforce the explicit passing of a value
    // for consistency on the front end.

    if (itemConfiguration.quantity === undefined || itemConfiguration.quantity === null) {
      throw new Error("Invalid itemConfiguration: " + JSON.stringify(itemConfiguration) + ", must contain a quantity.");
    }

    if (!(0, _helpers.isInteger)(itemConfiguration.quantity)) {
      throw new Error("Invalid itemConfiguration: " + JSON.stringify(itemConfiguration) + ", quantity must be an integer.");
    }
  });
};

exports.validateItemConfigurations = validateItemConfigurations;

var validateProductBasedOffers = function validateProductBasedOffers(productBasedOffers) {
  if (!Array.isArray(productBasedOffers)) {
    throw new Error("Invalid productBasedOffers: " + JSON.stringify(productBasedOffers) + ", must be null, undefined, or an array");
  }

  productBasedOffers.forEach(function (productBasedOfferId) {
    validateProductBasedOfferId(productBasedOfferId);
  });
};

exports.validateProductBasedOffers = validateProductBasedOffers;

var validatePurchaseableItemInConfig = function validatePurchaseableItemInConfig(itemConfigurations, productBasedOffers) {
  if ((!itemConfigurations || !itemConfigurations.length) && (!productBasedOffers || !productBasedOffers.length)) {
    throw new Error("Invalid purchaseConfig, must have at least one itemConfiguration or productBasedOffer");
  }
};

exports.validatePurchaseableItemInConfig = validatePurchaseableItemInConfig;

var hasRecurringItems = function hasRecurringItems(itemConfigurations, merchandiseMap) {
  return itemConfigurations.some(function (_ref) {
    var merchandiseId = _ref.merchandiseId;
    return merchandiseMap[merchandiseId].chargeType === _ChargeTypes.RECURRING;
  });
};

var validatePurchaseConfig = function validatePurchaseConfig(_ref2, merchandiseMap) {
  var termId = _ref2.termId,
      currencyCode = _ref2.currencyCode,
      itemConfigurations = _ref2.itemConfigurations,
      productBasedOffers = _ref2.productBasedOffers;
  validateTermId(termId);
  validateCurrencyCode(currencyCode);
  validateItemConfigurations(itemConfigurations);

  if (productBasedOffers) {
    validateProductBasedOffers(productBasedOffers);
  }

  validatePurchaseableItemInConfig(itemConfigurations, productBasedOffers);

  if (hasRecurringItems(itemConfigurations, merchandiseMap) && !termId) {
    throw new Error('Must include a termId if your itemConfigurations contain a RECURRING item');
  }
};

exports.validatePurchaseConfig = validatePurchaseConfig;

var validateUpgradeProduct = function validateUpgradeProduct(upgradeProduct) {
  if (upgradeProductValues.indexOf(upgradeProduct) === -1) {
    throw new Error("Invalid upgradeProduct, must be one of: " + upgradeProductValues);
  }
};

exports.validateUpgradeProduct = validateUpgradeProduct;